var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formPower",
            attrs: {
              "label-position": "top",
              model: _vm.formPower,
              rules: _vm.roleRules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "div",
              {
                class: {
                  editInput:
                    _vm.ifAddEdit &&
                    _vm.formPower.resourceType == "RESOURCE" &&
                    _vm.systemdata.directoryResource == "FALSE"
                },
                staticStyle: {
                  display: "flex",
                  "flex-wrap": "wrap",
                  "justify-content": "space-between"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "width-48",
                    attrs: { label: "资源类型", prop: "resourceType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: "请选择资源类型",
                          disabled: _vm.ifAddEdit || _vm.isaddresource
                        },
                        model: {
                          value: _vm.formPower.resourceType,
                          callback: function($$v) {
                            _vm.$set(_vm.formPower, "resourceType", $$v)
                          },
                          expression: "formPower.resourceType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "接口资源", value: "INTERFACE" }
                        }),
                        _c("el-option", {
                          attrs: { label: "PC菜单资源", value: "RESOURCE" }
                        }),
                        _c("el-option", {
                          attrs: { label: "MOB菜单资源", value: "MOBILE" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.IsInterface
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-48",
                        attrs: { label: "系统名称", prop: "systemId" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择系统名称",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formPower.systemId,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "systemId", $$v)
                              },
                              expression: "formPower.systemId"
                            }
                          },
                          _vm._l(_vm.AddformData[0].selectData, function(
                            option,
                            i
                          ) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: option.systemName,
                                value: option.systemId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.IsInterface &&
                _vm.IsLastMenu &&
                _vm.formPower.resourceType != "MOBILE"
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-48",
                        attrs: { label: "系统名称", prop: "systemId" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择系统名称",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formPower.systemId,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "systemId", $$v)
                              },
                              expression: "formPower.systemId"
                            }
                          },
                          _vm._l(_vm.AddformData[0].selectData, function(
                            option,
                            i
                          ) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: option.systemName,
                                value: option.systemId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.IsInterface &&
                !_vm.IsLastMenu &&
                _vm.formPower.resourceType != "MOBILE"
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-48",
                        attrs: { label: "系统名称", prop: "resourcesystemId" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择系统名称",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formPower.systemId,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "systemId", $$v)
                              },
                              expression: "formPower.systemId"
                            }
                          },
                          _vm._l(_vm.AddformData[0].selectData, function(
                            option,
                            i
                          ) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: option.systemName,
                                value: option.systemId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.formPower.resourceType == "MOBILE" && !_vm.ifAddEdit
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-48",
                        attrs: { label: "系统名称", prop: "systemId" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择系统名称",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formPower.systemId,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "systemId", $$v)
                              },
                              expression: "formPower.systemId"
                            }
                          },
                          _vm._l(_vm.AddformData[0].selectData, function(
                            option,
                            i
                          ) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: option.systemName,
                                value: option.systemId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.ifAddEdit &&
                _vm.formPower.resourceType == "RESOURCE" &&
                (_vm.systemdata == null || _vm.systemdata.path == null)
                  ? _c(
                      "el-form-item",
                      {
                        key: "SELECT",
                        staticClass: "width-48",
                        attrs: {
                          label: "是否是目录节点",
                          prop: "directoryResource"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: "请选择目录类型"
                            },
                            model: {
                              value: _vm.formPower.directoryResource,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formPower,
                                  "directoryResource",
                                  $$v
                                )
                              },
                              expression: "formPower.directoryResource"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "TRUE" }
                            }),
                            _c("el-option", {
                              attrs: { label: "否", value: "FALSE" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.ifAddEdit && _vm.formPower.resourceType == "RESOURCE"
                  ? _c(
                      "el-form-item",
                      {
                        key: "SELECT",
                        staticClass: "width-48",
                        attrs: {
                          label: "是否是目录节点",
                          prop: "directoryResource"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              disabled: _vm.ifAddEdit,
                              placeholder: "请选择目录类型"
                            },
                            model: {
                              value: _vm.formPower.directoryResource,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formPower,
                                  "directoryResource",
                                  $$v
                                )
                              },
                              expression: "formPower.directoryResource"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "TRUE" }
                            }),
                            _c("el-option", {
                              attrs: { label: "否", value: "FALSE" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.formPower.resourceType == "MOBILE"
                  ? _c(
                      "el-form-item",
                      {
                        key: "mobSelect",
                        staticClass: "width-48",
                        attrs: { label: "是否是系统节点", prop: "isSystemNode" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              disabled: _vm.ifAddEdit,
                              placeholder: "请选择节点类型"
                            },
                            model: {
                              value: _vm.formPower.isSystemNode,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "isSystemNode", $$v)
                              },
                              expression: "formPower.isSystemNode"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: "TRUE" }
                            }),
                            _c("el-option", {
                              attrs: { label: "否", value: "FALSE" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "width-48",
                    attrs: { label: "资源编号", prop: "resourceId" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "limit32",
                      attrs: {
                        size: "small",
                        placeholder: "请输入资源编号",
                        maxlength: "32",
                        "show-word-limit": "",
                        disabled: _vm.ifAddEdit
                      },
                      model: {
                        value: _vm.formPower.resourceId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formPower,
                            "resourceId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formPower.resourceId"
                      }
                    })
                  ],
                  1
                ),
                _vm.formPower.resourceType == "RESOURCE" && _vm.IsLastMenu
                  ? _c(
                      "el-form-item",
                      {
                        key: "mobSelect",
                        staticClass: "width-48",
                        attrs: {
                          label: "是否新页签打开",
                          prop: "isAllowOpenPage"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: "请选择资源打开类型"
                            },
                            model: {
                              value: _vm.formPower.isAllowOpenPage,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "isAllowOpenPage", $$v)
                              },
                              expression: "formPower.isAllowOpenPage"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: 1 }
                            }),
                            _c("el-option", {
                              attrs: { label: "否", value: 0 }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.ifAddEdit
                  ? _c(
                      "el-form-item",
                      { staticClass: "width-48", attrs: { label: "资源状态" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: "请选择资源状态"
                            },
                            model: {
                              value: _vm.formPower.resourceStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.formPower, "resourceStatus", $$v)
                              },
                              expression: "formPower.resourceStatus"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "有效", value: "VALID" }
                            }),
                            _c("el-option", {
                              attrs: { label: "失效", value: "INVALID" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "width-100",
                    attrs: { label: "资源名称", prop: "resourceName" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "limit256",
                      attrs: {
                        size: "small",
                        placeholder: "请输入资源名称",
                        maxlength: "256",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.formPower.resourceName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formPower,
                            "resourceName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formPower.resourceName"
                      }
                    })
                  ],
                  1
                ),
                !_vm.ifAddEdit && _vm.isaddresource
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-100",
                        attrs: { label: "父菜单", prop: "fathername" }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            disabled: "",
                            placeholder: ""
                          },
                          model: {
                            value: _vm.fathername,
                            callback: function($$v) {
                              _vm.fathername = $$v
                            },
                            expression: "fathername"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                (_vm.IsInterface ||
                  _vm.IsLastMenu ||
                  (_vm.systemdata != null && _vm.systemdata.path !== null)) &&
                _vm.formPower.resourceType != "MOBILE"
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-100",
                        attrs: { label: "资源路径", prop: "path" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _vm.formPower.resourceType != "INTERFACE" &&
                            _vm.prePath !== ""
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "48%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请选择公共系统"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.formPower,
                                          _vm.formPower.jumpSystemId,
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formPower.jumpSystemId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formPower,
                                          "jumpSystemId",
                                          $$v
                                        )
                                      },
                                      expression: "formPower.jumpSystemId"
                                    }
                                  },
                                  _vm._l(_vm.pubilcSystem, function(option, i) {
                                    return _c("el-option", {
                                      key: i,
                                      attrs: {
                                        label: option.baseUrl,
                                        value: option.systemId
                                      }
                                    })
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "limit256",
                              style:
                                _vm.formPower.resourceType != "INTERFACE" &&
                                _vm.prePath !== ""
                                  ? "width:48%"
                                  : "width:100%",
                              attrs: {
                                size: "small",
                                placeholder: "请输入资源路径",
                                maxlength: "256",
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.formPower.path,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formPower,
                                    "path",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formPower.path"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.formPower.resourceType == "MOBILE" &&
                _vm.formPower.isSystemNode == "FALSE"
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "width-100",
                        attrs: { label: "资源路径", prop: "path" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _vm.formPower.resourceType != "INTERFACE" &&
                            _vm.prePath !== ""
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "48%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请选择公共系统"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.formPower,
                                          _vm.formPower.jumpSystemId,
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formPower.jumpSystemId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formPower,
                                          "jumpSystemId",
                                          $$v
                                        )
                                      },
                                      expression: "formPower.jumpSystemId"
                                    }
                                  },
                                  _vm._l(_vm.pubilcSystem, function(option, i) {
                                    return _c("el-option", {
                                      key: i,
                                      attrs: {
                                        label: option.baseUrl,
                                        value: option.systemId
                                      }
                                    })
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "limit256",
                              style:
                                _vm.formPower.resourceType != "INTERFACE" &&
                                _vm.prePath !== ""
                                  ? "width:48%"
                                  : "width:100%",
                              attrs: {
                                size: "small",
                                placeholder: "请输入资源路径",
                                maxlength: "256",
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.formPower.path,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formPower,
                                    "path",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formPower.path"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "width-100",
                    attrs: { label: "资源描述", prop: "description" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "limit256",
                      attrs: {
                        size: "small",
                        placeholder: "请输入资源描述",
                        maxlength: "256",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.formPower.description,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formPower,
                            "description",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formPower.description"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between"
                }
              },
              [
                _vm.iseditfatherresource
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { flex: "1" },
                        attrs: { label: "目录资源图片", prop: "icon" }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "/platform/file/upload",
                                  "on-success": _vm.imgSuccess,
                                  "before-upload": _vm.beforeAvatarUpload,
                                  "show-file-list": false,
                                  headers: _vm.resquestheard,
                                  "list-type": "picture",
                                  accept: ".svg"
                                }
                              },
                              [
                                _c("input", {
                                  staticClass: "btn btn-red",
                                  attrs: { type: "button", value: "点击上传" }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    slot: "tip"
                                  },
                                  [_vm._v("只能上传svg图片，且不超过100kb")]
                                )
                              ]
                            ),
                            _vm.imgSrc
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      "margin-left": "20px"
                                    }
                                  },
                                  [
                                    _vm.imgSrc
                                      ? _c("remote-img", {
                                          attrs: {
                                            icon: _vm.imgSrc,
                                            width: "40px",
                                            height: "40px"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.IsMobile
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { flex: "1", "margin-bottom": "10px" },
                        attrs: { label: "功能资源图片", prop: "icon" }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "/platform/file/upload",
                                  "on-success": _vm.funcImgSuccess,
                                  "before-upload": _vm.beforeAvatarUpload,
                                  "show-file-list": false,
                                  headers: _vm.resquestheard,
                                  "list-type": "picture",
                                  accept: ".svg"
                                }
                              },
                              [
                                _c("input", {
                                  staticClass: "btn btn-red",
                                  attrs: { type: "button", value: "点击上传" }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    slot: "tip"
                                  },
                                  [_vm._v("只能上传svg图片，且不超过100kb")]
                                )
                              ]
                            ),
                            _vm.funcIcon
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      "margin-left": "20px"
                                    }
                                  },
                                  [
                                    _vm.funcIcon
                                      ? _c("remote-img", {
                                          attrs: {
                                            icon: _vm.funcIcon,
                                            width: "40px",
                                            height: "40px"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("default-func-icon", {
                                      attrs: { width: "40px", height: "40px" }
                                    })
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm.IsMobile
              ? _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { label: "功能资源图片", prop: "icon" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "/platform/file/upload",
                              "on-success": _vm.funcImgSuccess,
                              "before-upload": _vm.beforeAvatarUpload,
                              "show-file-list": false,
                              headers: _vm.resquestheard,
                              "list-type": "picture",
                              accept: ".svg"
                            }
                          },
                          [
                            _c("input", {
                              staticClass: "btn btn-red",
                              attrs: { type: "button", value: "点击上传" }
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                attrs: { slot: "tip" },
                                slot: "tip"
                              },
                              [_vm._v("只能上传svg图片，且不超过100kb")]
                            )
                          ]
                        ),
                        _vm.funcIcon
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "40px",
                                  height: "40px",
                                  "margin-left": "20px"
                                }
                              },
                              [
                                _vm.funcIcon
                                  ? _c("remote-img", {
                                      attrs: {
                                        icon: _vm.funcIcon,
                                        width: "40px",
                                        height: "40px"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("default-func-icon", {
                                  attrs: { width: "40px", height: "40px" }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer", staticStyle: { "margin-top": "0px" } },
      [
        _c(
          "el-button",
          {
            staticStyle: { "margin-right": "20px" },
            on: { click: _vm.cancelDailog }
          },
          [_vm._v("取消")]
        ),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.ifAddEdit ? "确认修改此资源？" : "确认添加此资源"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: { slot: "reference", type: "primary" },
                slot: "reference"
              },
              [_vm._v("确认")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }